import { getTheme, mergeStyles } from '@fluentui/react';

const theme = getTheme();

// Base pivot link styles
const pivotLinkBase = {
    borderRadius: '6px',
    padding: '6px 18px',
    margin: '0 2px',
    fontWeight: '900',
    color: theme.palette.neutralPrimary,
    display: 'flex',
    alignItems: 'center',
    minHeight: '36px',
    width: '100%',
    selectors: {
        ':hover': {
            background: theme.palette.neutralLight,
            color: theme.palette.neutralDark
        },
        '&.is-selected': {
            background: theme.palette.white,
            color: theme.palette.themePrimary,
            boxShadow: theme.effects.elevation4
        },
        img: {
            marginRight: '8px'
        },
        '& span': {
            fontWeight: '600 !important'
        },
        '& div': {
            fontWeight: '600 !important'
        },
        '& *': {
            fontWeight: '600 !important'
        }
    }
};

export const widgetStyles = {
    addWidgetButton: mergeStyles({
        background: theme.palette.neutralLighter,
        opacity: 0.6,
        cursor: 'pointer',
        borderRadius: 10,
        boxShadow: theme.effects.elevation16,
        padding: theme.spacing.l1,
        width: '250px',
        height: '100%',
        selectors: {
            ':hover': {
                opacity: 1
            }
        }
    }),

    widgetIconButtonStyles: {
        root: {
            borderRadius: '50%',
            background: theme.palette.neutralLight,
            color: theme.palette.neutralSecondary,
            width: '30px',
            height: '30px',
            margin: '2px',
            transition: 'background 0.2s'
        },
        rootHovered: {
            background: theme.palette.neutralQuaternaryAlt,
            color: theme.palette.neutralPrimary
        },
        icon: {
            fontSize: 18,
            color: theme.palette.neutralPrimary
        }
    },

    pivotRootClass: mergeStyles({
        background: theme.palette.neutralLighterAlt,
        borderRadius: 8,
        padding: 4,
        marginBottom: 16,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around'
    }),

    pivotLinkClass: mergeStyles(pivotLinkBase),

    pivotLinkDisabledClass: mergeStyles({
        ...pivotLinkBase,
        cursor: 'not-allowed',
        pointerEvents: 'none'
    }),

    modalStyles: mergeStyles({
        width: '800px',
        maxHeight: '800px',
        padding: '24px',
        borderRadius: 8,
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        overflowY: 'auto',
        overflowX: 'hidden'
    }),

    widgetHeader: {
        backgroundColor: theme.palette.neutralLighter
    }
};
